import { Wording } from '@/types';

export const MEDITATION_WORDING_NO: Wording = {
  components_header_media_content: 'Lydfiler',
  components_header_media_1: 'Meditasjoner',
  components_header_media_2: 'Podkast',
  components_header_text1: 'Guider',
  components_header_text2: 'Blogg',
  components_header_members: 'Medlemmer',
  hero_text: 'Der meditasjon møter stjernene',
  hero_button_text: 'Start reisen din innover',
  components_ressources_section_title: 'RESSURSER',
  components_ressources_subheader_text: 'Verktøy for indre fred, jording og hverdagsbalanse',
  components_ressources_span_text: 'Åpne døren til indre fred med våre håndplukkede meditasjoner og guider. Finn klarhet, gjenopprett kontakten med pusten din og bli i samsvar med din indre rytme – ett bevisst øyeblikk om gangen.',
  components_ressources_card_1_title: 'Speilbilde',
  components_ressources_card_1_text: 'Korte meditasjoner og lydrefleksjoner for å sentrere tankene dine og justere deg etter din kosmiske rytme.',
  components_ressources_card_2_title: 'Utforsk dypet',
  components_ressources_card_2_text: 'Reis utover overflaten med engasjerende guider som blander meditasjon, astrologi og selvransakelse for varig transformasjon.',
  components_ressources_link: 'Se mer',
  components_notes_and_google_title_1: 'Sjelfull veiledning',
  components_notes_and_google_title_2: 'Mindful Ritualer',
  components_notes_and_google_title_3: 'Guidede meditasjoner',
  components_review_google_text: 'Google-anmeldelser',
  media_content_section_title: 'LYDLØSNINGER',
  media_content_section_subheader_text: 'Våre meditasjoner',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Oppdag mer',
  text2_section_title: 'BLOGG',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'GUIDER',
  components_text1_subheader_text: 'Kosmisk kunnskap for daglig innretting',
  components_text1_span_text: 'Innrett deg etter universets rytmer: utforsk en kuratert samling av dyptgående astrologiske og meditative guider designet for å vekke indre klarhet, fordype selvinnsikt og støtte din reise mot sjelfull, himmelsk vekst.',
  components_text1_card_1_title: 'Åpen for stillheten',
  components_text1_card_1_text: 'Start reisen din med grunnleggende meditasjons- og astrologiguider – ideelt for søkere som er tiltrukket av indre stillhet, kosmiske mønstre og personlig innsikt.',
  components_text1_card_3_title: 'Sinn-kropp-kobling',
  components_text1_card_3_text: 'Avdekk de dypere lagene i din indre verden. Disse guidene beveger seg utover overflaten for å avdekke mening, følelser og bevisste mønstre som former opplevelsen din.',
  components_text1_card_2_title: 'Reflekter og integrer',
  components_text1_card_2_text: 'Fra emosjonelle blokkeringer til planetariske sykluser – disse guidene tilbyr verktøy for refleksjon, helbredelse og transformasjon gjennom mindful ritualer og astrologisk visdom.',
  components_text1_link: 'Se alle guider',
  components_footer_text: 'Våkn opp i deg selv: Din stillhet, din styrke',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Juridisk',
  components_footer_terms: 'Vilkår og betingelser',
  components_footer_privacy: 'Personvernerklæring',
  button_load_more: 'Last inn mer',
  page_media_1_content_hero_text: 'Meditasjoner',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Energiboost',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Guider',
  page_text1_section_title: 'Guider',
  page_text1_subheader_text: 'Våre guider',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Vennligst skriv inn e-postadressen din for å fortsette',
  enter_email_placeholder_email: 'E-post',
  enter_email_button_enter: 'Gå',
  components_login_success_text: 'Innlogging vellykket!',
  components_card_link_media_content: 'Lytt nå',
  components_card_link_text1_content: 'Se guide',
  components_card_link_text2_content: 'Utforske',
  tag_podcast: 'Podkast',
  tag_meditation: 'Meditasjon',
  page_media_content_menu_all: 'Alle',
};